import deepClone from 'lodash/cloneDeep'
import { useEffect, useRef } from 'react'

import type { MutableRefObject } from 'react'

export const usePrevious = <T>(value: T): T | undefined => {
  const ref: MutableRefObject<T | undefined> = useRef<T | undefined>(undefined)

  useEffect(() => {
    ref.current = deepClone(value)
  }, [value])

  return ref.current
}
